module.exports = __webpack_public_path__ + "static/media/Visa information.3b7b3aee.png";